import React from 'react';
import { Col, Row } from '@saucelabs/sl-component-grid';
import { Breadcrumbs } from '@saucelabs/ds-breadcrumbs/lib';

import GridContainer from '../Layout/GridContainer';
import { OrderSummaryFromPreview } from './OrderSummary/OrderSummaryFromPreview';
import { TwoStepsCheckoutProgress } from './TwoStepsCheckoutProgress';
import { ReviewContactDetails } from './ReviewContactDetails';
import { ROUTE_PARENT_SECTION } from '../../constants';
import trackEvent, { EVENTS } from '../../tracking';

const crumbList = [
  {
    name: 'Subscription and Billing',
    url: `/${ROUTE_PARENT_SECTION}`,
    onClick: () => trackEvent(EVENTS.PLANS_NAVIGATE_BACK, { checkout_step: 'Review and Purchase' }),
  },
  { name: 'Checkout' },
];

export const ReviewAndPurchaseStep = ({
  activeSubscriptions,
  allPlans,
  applyCoupon,
  checkoutError,
  checkoutPreview,
  checkoutPurchase,
  clearNotifications,
  clearPurchaseData,
  couponCode,
  fetchCheckoutPreview,
  orderItems,
  user,
}) => (
  <>
    <Breadcrumbs list={crumbList} />
    <TwoStepsCheckoutProgress checkoutStep={3} />
    <GridContainer>
      <Row>
        <Col
          lg={9}
        >
          <ReviewContactDetails
            applyCoupon={applyCoupon}
            checkoutPreview={checkoutPreview}
            couponCode={couponCode}
          />
        </Col>
        <Col lg={3}>
          <Row>
            <OrderSummaryFromPreview
              activeSubscriptions={activeSubscriptions}
              allPlans={allPlans}
              checkoutError={checkoutError}
              checkoutPreview={checkoutPreview}
              checkoutPurchase={checkoutPurchase}
              clearNotifications={clearNotifications}
              clearPurchaseData={clearPurchaseData}
              fetchCheckoutPreview={fetchCheckoutPreview}
              orderItems={orderItems}
              user={user}
            />
          </Row>
        </Col>
      </Row>
    </GridContainer>
  </>
);
